<mat-card>
    <mat-card-content>
        <div class="container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500"
            (scrolled)="onScroll()" [scrollWindow]="false">
            <ul class="timeline">
                <li *ngFor="let item of taskHistory; let i=index;" [ngClass]="{'timeline-inverted': i%2!==0}">
                    <div fxLayout="row">
                        <div fxFlex *ngIf="i%2!==0"></div>
                        <span fxFlex="46">{{getDisplayDate(item.task.meta.lastUpdated)}}
                            ({{item.task.meta.lastUpdated | date :'MM-DD-YYYY'}}), {{item.status}}</span>
                    </div>
                    <div class="timeline-badge" matTooltip="{{item.actor.fname}} {{item.actor.lname}}">
                        <ngx-avatar name="{{item.actor.fname}} {{item.actor.lname}}"
                            [bgColor]="bgColors[item.task.status]" fgColor="#fff" initialsSize="2">
                        </ngx-avatar>
                    </div>
                    <div class="timeline-panel" [ngClass]="item.task.status"
                        [ngStyle]="{'border-color': bgColors[item.task.status]}">
                        <div class="timeline-heading">
                            <h4 class="timeline-title m-b-0" fxLayoutAlign="start center">
                                <mat-icon class="m-r-5">dashboard</mat-icon>{{item.queueBoard.boardName}} /
                                <small class="text-muted">&nbsp;{{item.queue.queueName}}</small>
                            </h4>
                            <div>
                                <div fxLayoutAlign="start center">
                                    <mat-icon class="m-r-5">person</mat-icon>
                                    <span class="m-t-5">
                                        <span class="font-400">Last updated by: </span> {{item.actor.fname}}
                                        {{item.actor.lname}}</span>
                                </div>
                            </div>
                            <div>
                                <div fxLayoutAlign="start center">
                                    <mat-icon class="m-r-5">access_time</mat-icon>
                                    <span class="m-t-5">
                                        <span class="font-400">Time in queue: </span> 
                                        {{item.timeInQueue}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <ul class="timeline" *ngIf="isSkeleton">
                <li *ngFor="let item of fakeData; let i=index;" [ngClass]="{'timeline-inverted': i%2!==0}">
                    <div fxLayout="row">
                        <div fxFlex *ngIf="i%2!==0"></div>
                        <span fxFlex="46">
                            <ngx-skeleton-loader count="1" [theme]="{height: '25px', width: '50%', margin: '0px'}">
                            </ngx-skeleton-loader>
                        </span>
                    </div>
                    <div class="timeline-badge">
                        <ngx-skeleton-loader count="1" [theme]="{height: '50px'}">
                        </ngx-skeleton-loader>
                    </div>
                    <div class="timeline-panel">
                        <div class="timeline-heading">
                            <ngx-skeleton-loader count="1" [theme]="{height: '25px', margin: '0px'}">
                            </ngx-skeleton-loader>
                            <ngx-skeleton-loader count="1" [theme]="{height: '25px', width: '50%', margin: '0px'}">
                            </ngx-skeleton-loader>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </mat-card-content>
</mat-card>